import TCinemaSchedule from './t-video-shop';

export default TCinemaSchedule;